import React, { ReactNode } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '../../Base/IconFont';
import V2Message from '../../Others/V2Hint/V2Message';
import copy from 'copy-to-clipboard';
import { TooltipProps } from 'antd';

export interface V2TitleProps {
  /**
   * @description 标题类型, 可选[H1: 18px, H2: 16px, H3: 14px]
   * @default H1
   */
  type?: string;
  /**
   * @description 内容
   */
  text?: string;
  /**
   * @description 是否可以复制
   * @default false
   */
  needCopy?: boolean;
  /**
   * @description 右侧插槽
   */
  extra?: ReactNode;
  /**
   * @description 额外插入的外层class
   */
  className?: string;
  /**
   * @description 额外插入的外层id
   */
  id?: string;
  /**
   * @description 额外的外层样式
   */
  style?: React.CSSProperties;
  /**
   * @description 额外的内容样式
   */
  innerStyle?: React.CSSProperties;
  /**
   * @description 是否显示左侧分隔符
   */
  divider?: boolean;
  /**
   * @description slot插槽
   */
  children?: any;
  /**
   * @description 提示文字
   */
  tips?: string | ReactNode;
  /**
   * @description tips的tooltip的更多配置，详情请查看 https://ant.design/components/tooltip-cn
   */
  tipsTooltipConfig?: TooltipProps;
  /**
   * @description 是否加粗
   */
  bold?: boolean;
}
/**
* @description 便捷文档地址
* @see https://reactpc.lanhanba.net/components/feedback/v2title
*/
const V2Title: React.FC<V2TitleProps> = ({
  type = 'H1',
  text = '',
  needCopy,
  children,
  extra,
  className,
  style = {},
  innerStyle = {},
  id,
  divider = false,
  tips,
  tipsTooltipConfig = {},
  bold = false
}) => {
  const tipsTooltipProps: any = {
    placement: 'top',
    color: '#333333',
    title: tips,
    ...tipsTooltipConfig
  };
  const copyHandle = (text) => {
    copy(text);
    V2Message.success('复制成功');
  };
  return (
    <div id={id} className={cs(styles.v2TitleOuter, 'v2TitleOuter', className)} style={style}>
      <div className={cs(styles.v2Title, 'v2Title', bold && styles.v2TitleBold, styles[`v2Title${type}`])} style={innerStyle}>
        {
          divider && <div className={cs(styles.divider)}></div>
        }
        {children || text}
        {
          needCopy && <IconFont
            className={cs(styles.v2TitleCopy)}
            iconHref='pc-common-icon-ic_copy'
            functionality
            onClick={() => copyHandle(text)}
          />
        }
        {
          tips && <IconFont
            iconHref='pc-common-icon-ic_info'
            style={{
              marginLeft: '4px',
              color: '#ccc',
              fontSize: type === 'H3' ? '14px' : '16px'
            }}
            tooltipConfig={tipsTooltipProps}
          />
        }
      </div>
      <div className={cs(styles.v2TitleExtra, 'v2TitleExtra')}>
        {extra}
      </div>
    </div>
  );
};

export default V2Title;
